import React, { useEffect, useState, useRef } from 'react';
import QRCode from 'qrcode';
import { FaShieldAlt, FaCertificate, FaQrcode, FaTimesCircle, FaDownload, FaInfoCircle, FaEdit, FaPrint, FaCheckCircle, FaSearch, FaTrash } from 'react-icons/fa';
import uploadIcon from './../../assets/Images/Request_Property/upload.png';
import addIcon from './../../assets/Images/Request_Property/add.png';
import loader from './../../assets/Images/Request_Property/Loader.gif';
import PropertiesService from '../../Services/PropertiesService';
import logo from "./../../assets/Images/LOGOS/Docity_Logo_updatedDocity_Text_Logo_White.png";
import logoEmblem from "./../../assets/Images/LOGOS/Docity_Logo_updatedDocity_White_Emblem.png";
import { toast } from 'react-toastify';
import './Soc.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as pdfjsLib from "pdfjs-dist";
import requestsService from '../../Services/requests';
import PaymentPreviewCard from '../PaymentPreviewCard/PaymentPreviewCard';
import FilePreview from '../Common/FilePreview';
import { isApiErrorResponse } from '../../utils/fileHelpers';
import { extractOwnerNameFromDocument, extractDateFromDocument, formatReadableDate } from '../../utils/dateExtractor';
import FetchingCard from '../FetchingCard/FetchingCard';
import { Search, SlidersHorizontal, Eye, Pencil, Plus, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react';
import { Modal } from 'react-bootstrap';
import Product from '../RazorPay';
import DocityBlackWordmark, { forceBlackCertificateLogo } from '../Common/DocityBlackWordmark';

const SOC_BASE_AMOUNT = 1100;
const SOC_DISCOUNT = 500;
const SOC_NET_AMOUNT = SOC_BASE_AMOUNT - SOC_DISCOUNT;
const SOC_GST_RATE = 18;
const SOC_PAYABLE_AMOUNT = SOC_NET_AMOUNT + (SOC_NET_AMOUNT * SOC_GST_RATE) / 100;

const SOC = ({ isOpen, onClose, pageMode }) => {
    const certificateRef = useRef(null);
    const [activeTab, setActiveTab] = useState('history');
    const [showCertificate, setShowCertificate] = useState(false);
    const [RazorPayShow, setRazorPayShow] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isLoadingList, setIsLoadingList] = useState(false);
    const [finalCertData, setFinalCertData] = useState(null);
    const [effectiveQrCode, setEffectiveQrCode] = useState('');
    const [userdetails, setUserdetails] = useState(null);
    const [socList, setSocList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [sortOrder, setSortOrder] = useState('latest');
    const itemsPerPage = 5;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, sortOrder]);

    const [activeStep, setActiveStep] = useState('step1');
    const [completedSteps, setCompletedSteps] = useState({});
    const [legacyFiles, setLegacyFiles] = useState([
        { id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }
    ]);

    const [uploading, setUploading] = useState({
        PostOfficeSelfies: false,
    });

    const today = new Date().toISOString().split('T')[0];

    const [socForm, setSocForm] = useState({
        illegalActivityConsentChoice: "",
        PostOfficeSelfies: [],
        propertyAddress: '',
        ownerName: '',
    });
    const [uploadFieldErrors, setUploadFieldErrors] = useState({
        PostOfficeSelfies: '',
        legacyFiles: '',
    });
    const [aadhaarNumber, setAadhaarNumber] = useState('');
    const [aadhaarOtp, setAadhaarOtp] = useState('');
    const [aadhaarReferenceId, setAadhaarReferenceId] = useState('');
    const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
    const [isSendingAadhaarOtp, setIsSendingAadhaarOtp] = useState(false);
    const [isVerifyingAadhaarOtp, setIsVerifyingAadhaarOtp] = useState(false);
    const [aadhaarError, setAadhaarError] = useState('');
    const [aadhaarSuccessMessage, setAadhaarSuccessMessage] = useState('');
    const [showAadhaarOtpModal, setShowAadhaarOtpModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);
    const [editingSocId, setEditingSocId] = useState('');
    const [ownerNameSource, setOwnerNameSource] = useState(''); // 'extracted' | 'manual' | ''
    const [isOwnerNameEditing, setIsOwnerNameEditing] = useState(false);
    const [isExtractingName, setIsExtractingName] = useState(false);

    const userFromStorage = (() => {
        try { return JSON.parse(localStorage.getItem('userDetails')); } catch (e) { return null; }
    })();
    const resolvedUserId = userdetails?.user_id || userdetails?._id || userFromStorage?.user_id || userFromStorage?._id;
    console.log(userdetails, 'userdetails')
    const getPublicOrigin = () => {
        if (typeof window === 'undefined') return 'https://docity-user.netlify.app';
        const origin = window.location.origin;
        if (origin && !origin.includes('localhost') && !origin.includes('127.0.0.1')) {
            return origin;
        }
        const host = window.location.hostname;
        if (host && host !== 'localhost' && host !== '127.0.0.1') {
            return origin;
        }
        const port = window.location.port ? `:${window.location.port}` : ':3000';
        return `http://192.168.1.8${port}`;
    };
    const buildCertificateDownloadRoute = (type, certificateId, meta = {}) => {
        if (!certificateId) return '';
        const base = `${getPublicOrigin()}/#/certificate-download?type=${encodeURIComponent(type)}&id=${encodeURIComponent(certificateId)}`;
        const params = new URLSearchParams();
        if (meta.ownerName) params.append('name', meta.ownerName);
        if (meta.address) params.append('addr', meta.address);
        if (meta.expiresAt) params.append('exp', meta.expiresAt);
        if (meta.issuedAt || meta.createdAt) params.append('iss', meta.issuedAt || meta.createdAt);
        const query = params.toString();
        return query ? `${base}&${query}` : base;
    };
    const buildCertificateDownloadRouteBase = (type) => `${getPublicOrigin()}/#/certificate-download?type=${type}&id=`;
    const generateUniqueSealCode = (certificateId, ownerName, issuedDate) => {
        const source = `${certificateId || 'DOCITY'}|${ownerName || 'OWNER'}|${issuedDate || new Date().toISOString()}`;
        let hash = 0;

        for (let i = 0; i < source.length; i += 1) {
            hash = (hash << 5) - hash + source.charCodeAt(i);
            hash |= 0;
        }

        const encoded = Math.abs(hash).toString(36).toUpperCase().padStart(8, '0').slice(0, 8);
        return `DC-${encoded}`;
    };

    const formatDisplayDate = (dateValue) => {
        if (!dateValue) return 'N/A';
        const parsedDate = new Date(dateValue);
        if (Number.isNaN(parsedDate.getTime())) return 'N/A';
        return parsedDate.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    const resolveUserAddress = (user) => {
        if (!user) return '';
        const directAddress = user?.address || user?.Address || user?.fullAddress;
        if (directAddress) return String(directAddress).trim();

        return [user?.street, user?.locality, user?.city, user?.state, user?.pincode]
            .filter(Boolean)
            .map((item) => String(item).trim())
            .filter(Boolean)
            .join(', ');
    };



    const getBackendErrorMessage = (error, fallbackMessage = 'Something went wrong') => {
        if (!error) return fallbackMessage;
        if (typeof error === 'string') return error;

        const responseData = error?.response?.data;
        if (typeof responseData === 'string' && responseData.trim()) return responseData;

        const message =
            responseData?.message ||
            responseData?.error ||
            responseData?.details ||
            error?.message;

        return message || fallbackMessage;
    };

    useEffect(() => {
        if (isOpen) {
            if (!pageMode) {
                document.body.style.overflow = 'hidden';
            }
            const user = JSON.parse(localStorage.getItem('userDetails'));
            setUserdetails(user);
        } else {
            document.body.style.overflow = 'unset';
            resetModal();
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen, pageMode]);

    useEffect(() => {
        if (activeTab === 'history' && isOpen && userdetails) {
            fetchSocHistory();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, isOpen, userdetails]);

    useEffect(() => {
        let isMounted = true;
        const generateQr = async () => {
            if (!finalCertData) {
                setEffectiveQrCode('');
                return;
            }

            const certId = finalCertData?.certificateId || finalCertData?._id || finalCertData?.id;
            const certMeta = {
                ownerName: finalCertData?.ownerName || socForm?.ownerName?.trim() || userdetails?.name || '',
                address: finalCertData?.address || socForm?.propertyAddress?.trim() || resolveUserAddress(userdetails) || '',
                expiresAt: finalCertData?.expiresAt || '',
                issuedAt: finalCertData?.createdAt || '',
            };
            const routeUrl = buildCertificateDownloadRoute('soc', certId, certMeta);

            const directUrl =
                finalCertData?.downloadUrl ||
                finalCertData?.certificateDownloadUrl ||
                finalCertData?.pdfUrl ||
                finalCertData?.certificateUrl ||
                finalCertData?.fileUrl ||
                finalCertData?.url;

            const isValidHttpDirectUrl =
                typeof directUrl === 'string' &&
                /^https?:\/\//i.test(directUrl) &&
                !directUrl.includes('blob:') &&
                !directUrl.includes('#/certificate-download');

            const targetUrl = isValidHttpDirectUrl ? directUrl : (routeUrl || directUrl || '');

            if (targetUrl) {
                try {
                    const dataUrl = await QRCode.toDataURL(targetUrl, {
                        margin: 1,
                        width: 256,
                        color: { dark: '#000000', light: '#ffffff' }
                    });
                    if (isMounted) setEffectiveQrCode(dataUrl);
                } catch (err) {
                    console.error('[SOC] Error generating QR code:', err);
                    if (isMounted) setEffectiveQrCode(finalCertData?.qrCodeData || '');
                }
            } else if (finalCertData?.qrCodeData) {
                if (isMounted) setEffectiveQrCode(finalCertData.qrCodeData);
            }
        };

        generateQr();
        return () => { isMounted = false; };
    }, [finalCertData]);

    const resetModal = () => {
        setShowCertificate(false);
        setFinalCertData(null);
        setEffectiveQrCode('');
        setActiveTab('history');
        setActiveStep('step1');
        setLegacyFiles([
            { id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }
        ]);
        setSocForm({
            illegalActivityConsentChoice: "",
            PostOfficeSelfies: [],
            propertyAddress: '',
            ownerName: '',
        });
        setUploading({
            PostOfficeSelfies: false,
        });
        setUploadFieldErrors({
            PostOfficeSelfies: '',
            legacyFiles: '',
        });
        setAadhaarNumber('');
        setAadhaarOtp('');
        setAadhaarReferenceId('');
        setIsAadhaarVerified(false);
        setIsSendingAadhaarOtp(false);
        setIsVerifyingAadhaarOtp(false);
        setAadhaarError('');
        setAadhaarSuccessMessage('');
        setShowAadhaarOtpModal(false);
        setIsEditMode(false);
        setIsViewMode(false);
        setEditingSocId('');
        setOwnerNameSource('');
        setIsOwnerNameEditing(false);
        setSearchQuery('');
    };

    const handleForms = (step) => {
        setActiveStep(step);
    };

    const isStepRequiredFieldsFilled = (stepKey) => {
        switch (stepKey) {
            case "step1":
                return legacyFiles.every((f) => f.data && f.manualDate && f.declare);
            case "step2":
                return !!(
                    socForm.propertyAddress && socForm.propertyAddress.trim().length > 0 &&
                    socForm.illegalActivityConsentChoice === 'pledgeNoIllegalActivity' &&
                    socForm.PostOfficeSelfies && socForm.PostOfficeSelfies.length > 0
                );
            case "step3":
                return isAadhaarVerified;
            default:
                return false;
        }
    };

    const getStepProgressPercent = (stepKey) => {
        let filledCount = 0;
        let totalFields = 0;

        switch (stepKey) {
            case "step1":
                totalFields = legacyFiles.length * 3;
                legacyFiles.forEach(f => {
                    if (f.data || f.downloadUrl) filledCount++;
                    if (f.manualDate) filledCount++;
                    if (f.declare) filledCount++;
                });
                break;

            case "step2":
                totalFields = 3;
                if (socForm.propertyAddress && socForm.propertyAddress.trim().length > 0) filledCount++;
                if (socForm.illegalActivityConsentChoice) filledCount++;
                if (socForm.PostOfficeSelfies && socForm.PostOfficeSelfies.length > 0) filledCount++;
                break;

            case "step3":
                totalFields = 1;
                if (isAadhaarVerified) filledCount++;
                break;

            default:
                return 0;
        }

        if (totalFields === 0) return 0;

        const pct = Math.round((filledCount / totalFields) * 100);
        if (pct === 100) return 100;
        if (completedSteps[stepKey] && isStepRequiredFieldsFilled(stepKey)) return 100;
        return pct;
    };

    const getStepProgress = (stepKey) => {
        const pct = getStepProgressPercent(stepKey);
        if (pct === 100) return "complete";
        if (pct > 0) return "partial";
        return "empty";
    };

    const normalizeSocUploadItem = (item) => {
        const url = item?.downloadUrl || item?.previewUrl || item?.data || item?.url || '';
        return url ? {
            previewUrl: url,
            downloadUrl: url,
            originalName: item?.name || '',
            fileSize: item?.fileSize || 0,
        } : null;
    };

    const buildLegacyDocumentsPayload = () =>
        legacyFiles
            .filter((file) => file?.data || file?.downloadUrl)
            .map((file, index) => ({
                name: file?.name || `Document ${index + 1}`,
                data: file?.downloadUrl || file?.data,
                manualDate: file?.manualDate || today,
            }));

    const isExcludedSocUtilityDocName = (name = '') => {
        const normalizedName = String(name).toLowerCase();
        return (
            normalizedName.includes('lpg receipt') ||
            normalizedName.includes('property picture') ||
            normalizedName.includes('post office selfie')
        );
    };

    const handleEditSoc = (soc, event) => {
        event?.stopPropagation?.();
        const normalizedSelfies = (soc?.PostOfficeSelfies || []).map(normalizeSocUploadItem).filter(Boolean);
        const mergedSocDocs = [];
        const pushDoc = (url, name, manualDate) => {
            if (!url) return;
            if (isExcludedSocUtilityDocName(name)) return;
            mergedSocDocs.push({
                id: Date.now() + mergedSocDocs.length,
                data: url,
                downloadUrl: url,
                manualDate: manualDate || today,
                declare: true,
                name: name || `Document ${mergedSocDocs.length + 1}`,
                isLoading: false,
                fileSize: 0,
            });
        };

        const socDocumentsArray = Array.isArray(soc?.documents) ? soc.documents : [];
        const socFilesArray = Array.isArray(soc?.filesData) ? soc.filesData : [];

        if (socDocumentsArray.length > 0) {
            socDocumentsArray.forEach((file, index) => {
                pushDoc(file?.data || file?.downloadUrl || file?.previewUrl, file?.name || `Document ${index + 1}`, file?.manualDate);
            });
        } else if (socFilesArray.length > 0) {
            socFilesArray.forEach((file, index) => {
                pushDoc(file?.data || file?.downloadUrl || file?.previewUrl, file?.name || `Document ${index + 1}`, file?.manualDate);
            });
        }

        const normalizedLegacyFiles = mergedSocDocs.length > 0
            ? mergedSocDocs
            : [{ id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }];

        const existingOwnerName =
            soc?.ownerName ||
            soc?.userId?.name ||
            [soc?.userId?.firstName, soc?.userId?.lastName].filter(Boolean).join(' ') ||
            soc?.name ||
            userdetails?.name ||
            '';

        setLegacyFiles(normalizedLegacyFiles);
        setSocForm((prev) => ({
            ...prev,
            ownerName: existingOwnerName,
            illegalActivityConsentChoice: soc?.illegalActivityConsentChoice || '',
            PostOfficeSelfies: normalizedSelfies,
            propertyAddress: soc?.address || '',
        }));
        setOwnerNameSource(existingOwnerName ? 'saved' : '');
        setIsOwnerNameEditing(false);
        setIsEditMode(true);
        setIsViewMode(false);
        setEditingSocId(soc?._id || soc?.socId || '');
        setActiveTab('generate');
        setActiveStep('step1');
        setShowCertificate(false);
        setFinalCertData(null);
    };

    const handleViewSocInGenerate = (soc, event) => {
        event?.stopPropagation?.();
        const normalizedSelfies = (soc?.PostOfficeSelfies || []).map(normalizeSocUploadItem).filter(Boolean);
        const mergedSocDocs = [];
        const pushDoc = (url, name, manualDate) => {
            if (!url) return;
            if (isExcludedSocUtilityDocName(name)) return;
            mergedSocDocs.push({
                id: Date.now() + mergedSocDocs.length,
                data: url,
                downloadUrl: url,
                manualDate: manualDate || today,
                declare: true,
                name: name || `Document ${mergedSocDocs.length + 1}`,
                isLoading: false,
                fileSize: 0,
            });
        };
        const socDocumentsArray = Array.isArray(soc?.documents) ? soc.documents : [];
        const socFilesArray = Array.isArray(soc?.filesData) ? soc.filesData : [];

        if (socDocumentsArray.length > 0) {
            socDocumentsArray.forEach((file, index) => {
                pushDoc(file?.data || file?.downloadUrl || file?.previewUrl, file?.name || `Document ${index + 1}`, file?.manualDate);
            });
        } else if (socFilesArray.length > 0) {
            socFilesArray.forEach((file, index) => {
                pushDoc(file?.data || file?.downloadUrl || file?.previewUrl, file?.name || `Document ${index + 1}`, file?.manualDate);
            });
        }

        const existingOwnerName =
            soc?.ownerName ||
            soc?.userId?.name ||
            [soc?.userId?.firstName, soc?.userId?.lastName].filter(Boolean).join(' ') ||
            soc?.name ||
            userdetails?.name ||
            '';

        setLegacyFiles(mergedSocDocs.length > 0
            ? mergedSocDocs
            : [{ id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }]);
        setSocForm((prev) => ({
            ...prev,
            ownerName: existingOwnerName,
            illegalActivityConsentChoice: soc?.illegalActivityConsentChoice || '',
            PostOfficeSelfies: normalizedSelfies,
            propertyAddress: soc?.address || '',
        }));
        setOwnerNameSource(existingOwnerName ? 'saved' : '');
        setIsOwnerNameEditing(false);
        setIsEditMode(false);
        setIsViewMode(true);
        setEditingSocId('');
        setActiveTab('generate');
        setActiveStep('step1');
        setShowCertificate(false);
        setFinalCertData(null);
    };

    const handleBackToGenerateTab = () => {
        resetModal();
        setActiveTab('generate');
        setActiveStep('step1');
    };

    const handleUpdateSocFromLegacyGenerate = async () => {
        if (!isEditMode || !editingSocId) return;
        if (!resolvedUserId) {
            toast.error('Login required');
            return;
        }
        if (!socForm.ownerName || !socForm.ownerName.trim()) {
            toast.error('Owner Name (As per Document) is required.');
            return;
        }

        const documents = buildLegacyDocumentsPayload();
        if (!documents.length) {
            toast.error('Please upload at least one document to update SOC');
            return;
        }

        setIsSaving(true);
        try {
            const response = await PropertiesService.updateSoc({
                socId: editingSocId,
                _id: editingSocId,
                userId: resolvedUserId,
                ownerName: socForm.ownerName.trim(),
                address: socForm.propertyAddress.trim() || resolveUserAddress(userdetails),
                illegalActivityConsentChoice: socForm.illegalActivityConsentChoice,
                PostOfficeSelfies: socForm.PostOfficeSelfies.map((file) => file.downloadUrl || file.previewUrl || file),
                documents,
                filesData: documents,
                isFilled: true,
            });

            if (typeof response === 'string' && response.toLowerCase().includes('error')) {
                throw new Error(response);
            }

            toast.success('SOC documents updated successfully');
            await fetchSocHistory();
            setActiveTab('history');
            setIsEditMode(false);
            setEditingSocId('');
        } catch (error) {
            toast.error(getBackendErrorMessage(error, 'Failed to update SOC'));
        } finally {
            setIsSaving(false);
        }
    };

    const handleLegacyGenerate = async () => {
        if (!socForm.ownerName || !socForm.ownerName.trim()) {
            toast.error('Owner Name (As per Document) is required.');
            return;
        }
        if (!isLegacyReady || isViewMode) return;
        if (isEditMode) {
            await handleUpdateSocFromLegacyGenerate();
            return;
        }
        // For new SOC flow, first Generate only moves to compliance.
        // Final API call happens in next generate/payment step.
        setCompletedSteps(prev => ({ ...prev, step1: true }));
        setActiveStep('step2');
    };

    const handleAadhaarNumberChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 12);
        setAadhaarNumber(digits);
        setAadhaarOtp('');
        setAadhaarReferenceId('');
        setShowAadhaarOtpModal(false);
        setIsAadhaarVerified(false);
        setAadhaarError('');
        setAadhaarSuccessMessage('');
    };

    const handleAadhaarOtpChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
        setAadhaarOtp(digits);
        setAadhaarError('');
    };

    const handleSendAadhaarOtp = async () => {
        if (isSendingAadhaarOtp) return;
        if (aadhaarNumber.length !== 12) {
            setAadhaarError('Aadhaar number must be 12 digits.');
            return;
        }
        // Temporarily bypass OTP integration; enable direct verify until subscription is finalized.
        setAadhaarError('');
        setAadhaarOtp('');
        setAadhaarReferenceId('');
        setShowAadhaarOtpModal(false);
        setIsAadhaarVerified(true);
        setAadhaarSuccessMessage('Aadhaar verified successfully.');
        toast.success('Aadhaar verified successfully.');
    };

    const handleVerifyAadhaarOtp = async () => {
        if (isVerifyingAadhaarOtp) return;
        if (!aadhaarReferenceId) {
            setAadhaarError('Please send OTP first.');
            return;
        }
        if (aadhaarOtp.length !== 6) {
            setAadhaarError('OTP must be 6 digits.');
            return;
        }

        setIsVerifyingAadhaarOtp(true);
        setAadhaarError('');
        setAadhaarSuccessMessage('');
        try {
            const response = await requestsService.validateAadharOtp({
                reference_id: String(aadhaarReferenceId),
                otp: aadhaarOtp,
            });
            if (typeof response === 'string') throw new Error(response);
            const message = response?.data?.message || response?.message || '';
            const isVerified = response?.code === 200 || /verified|success/i.test(String(message || ''));
            if (!isVerified || /invalid/i.test(String(message || ''))) {
                throw new Error(message || 'Invalid OTP');
            }
            setIsAadhaarVerified(true);
            setAadhaarSuccessMessage('Aadhaar verified successfully.');
            setShowAadhaarOtpModal(false);
            toast.success('Aadhaar verified successfully.');
        } catch (error) {
            const message = getBackendErrorMessage(error, 'Failed to verify Aadhaar OTP');
            setIsAadhaarVerified(false);
            setAadhaarError(message);
            toast.error(message);
        } finally {
            setIsVerifyingAadhaarOtp(false);
        }
    };

    const fetchSocHistory = async () => {
        setIsLoadingList(true);
        try {
            const primaryId = resolvedUserId || userdetails?.user_id || userdetails?._id;
            const alternateId = userdetails?._id !== primaryId ? userdetails?._id : userdetails?.user_id;

            let response = await requestsService.getsocs({ userId: primaryId });
            let list = response?.data || response || [];

            if ((!Array.isArray(list) || list.length === 0) && alternateId && alternateId !== primaryId) {
                try {
                    const altResponse = await requestsService.getsocs({ userId: alternateId });
                    const altList = altResponse?.data || altResponse || [];
                    if (Array.isArray(altList) && altList.length > 0) {
                        list = altList;
                    }
                } catch (altErr) {
                    console.warn('[SOC] Alternate user ID lookup notice:', altErr);
                }
            }

            const sorted = Array.isArray(list)
                ? [...list].sort((a, b) => {
                    const aTime = new Date(a?.createdAt || 0).getTime();
                    const bTime = new Date(b?.createdAt || 0).getTime();
                    return bTime - aTime;
                })
                : [];
            setSocList(sorted);
        } catch (error) {
            toast.error(getBackendErrorMessage(error, 'Failed to load certificate history'));
        } finally {
            setIsLoadingList(false);
        }
    };

    const uploadFiles = async (event, field, isMultiple = false) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (!selectedFiles.length) return;

        // Check file size limits for preview compatibility
        const maxSize = 10 * 1024 * 1024;
        const oversizedFiles = selectedFiles.filter(file => file.size > maxSize);

        if (oversizedFiles.length > 0) {
            const fileNames = oversizedFiles.map(f => f.name).join(', ');
            const errorMsg = `File(s) too large for preview: ${fileNames}. Maximum size is ${(maxSize / (1024 * 1024))}MB.`;
            setUploadFieldErrors((prev) => ({ ...prev, [field]: errorMsg }));
            toast.error(errorMsg);
            return;
        }

        setUploading((prev) => ({ ...prev, [field]: true }));

        try {
            const uploadedUrls = [];

            for (const file of selectedFiles) {
                const localPreviewUrl = URL.createObjectURL(file);
                let finalUrl = localPreviewUrl;
                try {
                    const formData = new FormData();
                    formData.append('image', file);
                    const response = await PropertiesService.UploadFiles(formData);
                    if (response && !isApiErrorResponse(response)) {
                        finalUrl = response?.previewUrl || (response?.files && response.files[0]?.previewUrl) || response?.Location || localPreviewUrl;
                    }
                } catch (err) {
                    console.warn('[SOC] Backend S3 upload error, using local preview fallback:', err);
                }

                uploadedUrls.push({
                    previewUrl: finalUrl,
                    downloadUrl: finalUrl,
                    fileSize: file.size,
                    originalName: file.name,
                });

                // Extract owner name asynchronously in background without blocking upload UI
                extractOwnerNameFromDocument(file, pdfjsLib).then((extractedName) => {
                    if (extractedName) {
                        setSocForm((prev) => ({
                            ...prev,
                            ownerName: prev.ownerName || extractedName,
                        }));
                        setOwnerNameSource('extracted');
                        setIsOwnerNameEditing(false);
                    }
                }).catch((ocrErr) => {
                    console.error('[SOC] Background owner extraction error:', ocrErr);
                });
            }

            setSocForm((prev) => ({
                ...prev,
                [field]: isMultiple ? [...prev[field], ...uploadedUrls] : [uploadedUrls[0]],
            }));
            setUploadFieldErrors((prev) => ({ ...prev, [field]: '' }));


        } catch (error) {
            const message = getBackendErrorMessage(error, 'Upload failed');
            setUploadFieldErrors((prev) => ({ ...prev, [field]: message }));
            toast.error(message);
        } finally {
            setUploading((prev) => ({ ...prev, [field]: false }));
            event.target.value = '';
        }
    };

    const addNewUploadSlot = () => {
        setLegacyFiles((prev) => ([
            ...prev,
            { id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }
        ]));
    };

    const handleLegacyFileUpload = async (e, id) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check file size limits for preview compatibility
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            const errorMsg = `File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of ${(maxSize / (1024 * 1024))}MB for preview. Please choose a smaller file.`;
            setUploadFieldErrors((prev) => ({ ...prev, legacyFiles: errorMsg }));
            toast.error(errorMsg);
            return;
        }

        const localPreviewUrl = URL.createObjectURL(file);

        // 1. Immediately update tile state: show spinning loader & start extraction
        setLegacyFiles((prev) => prev.map((f) =>
            f.id === id
                ? {
                    ...f,
                    data: null,
                    downloadUrl: localPreviewUrl,
                    name: file.name,
                    fileSize: file.size,
                    isLoading: true,
                    isExtracting: true,
                }
                : f
        ));
        setUploadFieldErrors((prev) => ({ ...prev, legacyFiles: '' }));
        setIsExtractingName(true);

        // 2. Start INSTANT Date Extraction immediately using client-side reader
        extractDateFromDocument(file, pdfjsLib).then((res) => {
            const extractedDate = res?.date || '';
            const allDates = res?.allDates || [];
            setLegacyFiles((prev) => prev.map((f) =>
                f.id === id
                    ? {
                        ...f,
                        manualDate: extractedDate,
                        allDates: allDates,
                        declare: !!extractedDate,
                        isExtracting: false,
                    }
                    : f
            ));
        }).catch((dateErr) => {
            console.error('[SOC] Instant date extraction error:', dateErr);
            setLegacyFiles((prev) => prev.map((f) =>
                f.id === id ? { ...f, isExtracting: false } : f
            ));
        });

        // 3. Start INSTANT Owner Name Extraction immediately using client-side reader
        extractOwnerNameFromDocument(file, pdfjsLib).then((extractedName) => {
            if (extractedName) {
                setSocForm((prev) => ({
                    ...prev,
                    ownerName: prev.ownerName || extractedName,
                }));
                setOwnerNameSource('extracted');
                setIsOwnerNameEditing(false);
            }
        }).catch((ocrErr) => {
            console.error('[SOC] Instant owner name extraction error:', ocrErr);
        }).finally(() => {
            setIsExtractingName(false);
        });

        // 4. Perform S3 Upload in parallel, then clear isLoading spinner
        let finalPreviewUrl = localPreviewUrl;
        let finalDownloadUrl = localPreviewUrl;

        try {
            const formData = new FormData();
            formData.append('image', file);
            const response = await PropertiesService.UploadFiles(formData);

            if (response && !isApiErrorResponse(response)) {
                finalPreviewUrl = response?.previewUrl || response?.Location || localPreviewUrl;
                finalDownloadUrl = response?.Location || finalPreviewUrl;

                const serverExtractedName = response?.extractedOwnerName || (response?.files && response.files[0]?.extractedOwnerName) || '';
                if (serverExtractedName) {
                    setSocForm((prev) => ({ ...prev, ownerName: serverExtractedName }));
                    setOwnerNameSource('extracted');
                    setIsOwnerNameEditing(false);
                }
            }
        } catch (uploadErr) {
            console.warn('[SOC] S3 Upload fallback to local file preview:', uploadErr);
        } finally {
            // S3 upload complete -> stop spinning loader
            setLegacyFiles((prev) => prev.map((f) =>
                f.id === id
                    ? {
                        ...f,
                        data: finalPreviewUrl,
                        downloadUrl: finalDownloadUrl,
                        isLoading: false,
                    }
                    : f
            ));
        }
    };

    const removeLegacyFile = (id) => {
        if (legacyFiles.length === 1) {
            setLegacyFiles([{ id: Date.now(), data: null, manualDate: '', declare: false, name: '', isLoading: false }]);
            return;
        }
        setLegacyFiles((prev) => prev.filter((f) => f.id !== id));
    };

    const handleLegacyDateChange = (id, field, value) => {
        setLegacyFiles((prev) => prev.map((f) => {
            if (f.id !== id) return f;

            if (field === 'manualDate') {
                return {
                    ...f,
                    manualDate: value,
                    declare: value ? f.declare : false,
                };
            }

            return { ...f, [field]: value };
        }));
    };

    const removeUploadedItem = (field, indexToRemove) => {
        setSocForm((prev) => ({
            ...prev,
            [field]: (prev[field] || []).filter((_, index) => index !== indexToRemove),
        }));
    };

    const openHiddenFileInput = (inputId) => {
        document.getElementById(inputId)?.click();
    };

    const handleGenerateCertificate = async () => {
        const userObj = userdetails || userFromStorage;
        const currentUserId = resolvedUserId || userObj?.user_id || userObj?._id;

        if (!currentUserId) { toast.error('Login required'); return; }
        if (!isAadhaarVerified) {
            setAadhaarError('Please verify Aadhaar before proceeding.');
            toast.error('Please verify Aadhaar before proceeding.');
            return;
        }

        if (!socForm.ownerName || !socForm.ownerName.trim()) {
            toast.error('Owner Name (As per Document) is required.');
            return;
        }

        if (!socForm.propertyAddress || !socForm.propertyAddress.trim()) {
            toast.error('Please provide property address');
            return;
        }

        if (!socForm.illegalActivityConsentChoice) {
            toast.error('Please select consent option');
            return;
        }

        if (!socForm.PostOfficeSelfies || !socForm.PostOfficeSelfies.length) {
            toast.error('Please upload property pictures');
            return;
        }

        setIsSaving(true);

        const filesData = [
            ...legacyFiles
                .filter((f) => f.data)
                .map((f, index) => ({
                    name: f.name || `Document ${index + 1}`,
                    data: f.downloadUrl || f.data,
                    manualDate: f.manualDate || today,
                })),

            ...socForm.PostOfficeSelfies.map((file, index) => ({
                name: `Property Picture ${index + 1}`,
                data: file.downloadUrl || file.previewUrl || file,
                manualDate: today,
            })),
        ];

        const payload = {
            userId: currentUserId,
            address: socForm.propertyAddress.trim() || resolveUserAddress(userObj),
            illegalActivityConsentChoice: socForm.illegalActivityConsentChoice,
            PostOfficeSelfies: socForm.PostOfficeSelfies.map((file) => file.downloadUrl || file.previewUrl || file),
            filesData,
            ownerName: socForm.ownerName.trim(),
            certificateDownloadRouteBase: buildCertificateDownloadRouteBase('soc'),
            paymentDone: true,
            paymentStatus: true,
            isPaid: true,
            paymentFor: "SOC",
            amount: SOC_PAYABLE_AMOUNT,
            price: SOC_PAYABLE_AMOUNT,
        };
        console.log(payload, 'payload2222')
        try {
            const response = await PropertiesService.generatesoc(payload);

            if (typeof response === 'string' && response.toLowerCase().includes('error')) {
                throw new Error(response);
            }
            if (response?.message && String(response.message).toLowerCase().includes('error')) {
                throw new Error(response.message);
            }

            const responseData = response?.data || response;
            if (!responseData) {
                throw new Error('Empty response from SOC generate API');
            }

            const normalizedCertificate = {
                ...responseData,
                qrCodeData: responseData?.qrCodeData || response?.qrCode || responseData?.qrCode || '',
                certificateId: responseData?.certificateId || response?.certificateId || '',
                downloadUrl:
                    responseData?.downloadUrl ||
                    responseData?.certificateDownloadUrl ||
                    responseData?.pdfUrl ||
                    responseData?.certificateUrl ||
                    buildCertificateDownloadRoute('soc', responseData?.certificateId || response?.certificateId || '', {
                        ownerName: response?.ownerName || responseData?.ownerName || responseData?.data?.ownerName || socForm.ownerName.trim() || userObj?.name || '',
                        address: responseData?.address || responseData?.data?.address || resolveUserAddress(userObj) || socForm.propertyAddress.trim() || '',
                        expiresAt: responseData?.expiresAt || responseData?.data?.expiresAt || '',
                        issuedAt: responseData?.createdAt || '',
                    }),
                address: responseData?.address || responseData?.data?.address || resolveUserAddress(userObj) || '',
                expiresAt: responseData?.expiresAt || responseData?.data?.expiresAt || '',
                ownerName: response?.ownerName || responseData?.ownerName || responseData?.data?.ownerName || socForm.ownerName.trim() || userObj?.name || '',
            };

            setFinalCertData(normalizedCertificate);
            setShowCertificate(true);
            toast.success("Certificate Generated & Saved to Database Successfully");
            await fetchSocHistory();
            setActiveTab('history');
        } catch (error) {
            console.error('SOC generation/save error:', error);
            toast.error(getBackendErrorMessage(error, 'Failed to generate certificate'));
        } finally { setIsSaving(false); }
    };

    const downloadCertificate = async () => {
        if (isDownloading) return;
        setIsDownloading(true);

        try {
            const element = certificateRef.current;
            if (!element) return;

            if (document?.fonts?.ready) {
                await document.fonts.ready;
            }

            const certId = finalCertData?.certificateId || finalCertData?._id || 'Doc';
            const safeFileName = String(certId)
                .replace(/[^a-zA-Z0-9-_]/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '') || 'Doc';

            const canvas = await html2canvas(element, {
                scale: Math.max(2, window.devicePixelRatio || 1.5),
                useCORS: true,
                allowTaint: true,
                imageTimeout: 0,
                logging: false,
                backgroundColor: '#d8e5e5',
                ignoreElements: (node) => node?.dataset?.html2canvasIgnore === 'true',
                onclone: (clonedDoc) => {
                    clonedDoc.querySelectorAll('[data-export-hide="true"]').forEach((btn) => {
                        btn.style.display = 'none';
                    });
                    forceBlackCertificateLogo(clonedDoc);
                }
            });

            const imgData = canvas.toDataURL("image/png", 1.0);

            try {
                const pdf = new jsPDF({
                    orientation: canvas.width > canvas.height ? 'l' : 'p',
                    unit: 'px',
                    format: [canvas.width, canvas.height],
                    compress: true,
                });

                pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height, undefined, 'FAST');
                pdf.save(`SOC-${safeFileName}.pdf`);
                toast.success("Certificate downloaded successfully!");
            } catch (pdfErr) {
                console.warn("[SOC] PDF fallback to PNG image:", pdfErr);
                const link = document.createElement('a');
                link.href = imgData;
                link.download = `SOC-${safeFileName}.png`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success("Certificate downloaded as high-res image!");
            }
        } catch (error) {
            console.error("PDF Generation Error:", error);
            // Fallback attempt with basic scale
            try {
                const element = certificateRef.current;
                const canvas = await html2canvas(element, {
                    scale: 1.5,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#d8e5e5',
                    onclone: (clonedDoc) => {
                        clonedDoc.querySelectorAll('[data-export-hide="true"]').forEach((btn) => {
                            btn.style.display = 'none';
                        });
                        forceBlackCertificateLogo(clonedDoc);
                    }
                });
                const imgData = canvas.toDataURL("image/png", 1.0);
                const link = document.createElement('a');
                link.href = imgData;
                link.download = `SOC-Certificate.png`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success("Certificate downloaded as image!");
            } catch (fallbackError) {
                console.error("Fallback capture error:", fallbackError);
                toast.error("Failed to generate PDF. Please try again.");
            }
        } finally {
            setIsDownloading(false);
        }
    };

    const isReadyForCertificate =
        socForm.propertyAddress && socForm.propertyAddress.trim().length > 0 &&
        socForm.PostOfficeSelfies.length > 0 &&
        socForm.illegalActivityConsentChoice === 'pledgeNoIllegalActivity';

    const isLegacyReady = legacyFiles.every((f) => f.data && f.manualDate && f.declare) && Boolean(socForm.ownerName && socForm.ownerName.trim());
    const resolvedSocAddress = socForm.propertyAddress.trim() || resolveUserAddress(userdetails);
    const isSocPaymentReady = isLegacyReady && isReadyForCertificate;

    const socPaymentChecks = [
        {
            label: 'Legacy occupation documents verified',
            detail: `${legacyFiles.filter((file) => file.data && file.manualDate && file.declare).length} document(s) marked verified`,
            completed: isLegacyReady,
        },

        {
            label: 'Illegal activity consent confirmed',
            detail: 'Applicant accepted the unlawful activity declaration',
            completed: socForm.illegalActivityConsentChoice === 'pledgeNoIllegalActivity',
        },
        {
            label: 'Post office selfie uploaded',
            detail: `${socForm.PostOfficeSelfies.length} file(s) attached`,
            completed: socForm.PostOfficeSelfies.length > 0,
        },

        {
            label: 'Property address confirmed',
            detail: resolvedSocAddress || 'Using saved user address at certificate time',
            completed: Boolean(resolvedSocAddress),
        },
    ];

    const socPaymentServicePoints = [
        'SOC pre-generation verification review',
        'Review of uploaded occupation and utility proof documents',
        'Certificate issuance support with verified applicant details',
        'Digitally generated self-occupation certificate with QR code',
    ];

    const handleProceedToSocPayment = () => {
        if (!isSocPaymentReady) {
            toast.error('Complete all required SOC checks before payment');
            return;
        }
        setCompletedSteps(prev => ({ ...prev, step2: true }));
        setActiveStep('step3');
    };

    const handleUpdateSoc = async () => {
        if (!editingSocId) {
            toast.error('SOC record not found for update');
            return;
        }
        if (!resolvedUserId) {
            toast.error('Login required');
            return;
        }
        const payload = {
            socId: editingSocId,
            _id: editingSocId,
            userId: resolvedUserId,
            address: socForm.propertyAddress.trim() || resolveUserAddress(userdetails),
            illegalActivityConsentChoice: socForm.illegalActivityConsentChoice,
            PostOfficeSelfies: socForm.PostOfficeSelfies.map((file) => file.downloadUrl || file.previewUrl || file),

            isFilled: true,
        };
        setIsSaving(true);
        try {
            const response = await PropertiesService.updateSoc(payload);
            if (typeof response === 'string' && response.toLowerCase().includes('error')) {
                throw new Error(response);
            }
            toast.success('SOC updated successfully');
            setIsEditMode(false);
            setEditingSocId('');
            await fetchSocHistory();
            setActiveTab('history');
        } catch (error) {
            toast.error(getBackendErrorMessage(error, 'Failed to update SOC'));
        } finally {
            setIsSaving(false);
        }
    };

    const getFormattedCertId = (item) => {
        if (item.certificateId) return item.certificateId;
        const date = new Date(item.createdAt);
        const year = !Number.isNaN(date.getTime()) ? date.getFullYear() : '2026';
        const idPart = item._id ? item._id.slice(-5).toUpperCase() : '88492';
        return `DOC-${year}-${idPart}-SOC`;
    };

    const getFormattedIssuanceDate = (item) => {
        const date = new Date(item.createdAt);
        if (Number.isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    const exportToCSV = () => {
        if (socList.length === 0) {
            toast.error("No data to export");
            return;
        }
        const headers = ["Certificate ID", "Owner Name", "Address", "Created At", "Status"];
        const rows = socList.map(item => [
            item.certificateId || getFormattedCertId(item),
            item.ownerName || userdetails?.name || 'N/A',
            item.address || 'No Address',
            new Date(item.createdAt).toLocaleDateString(),
            item.certificateId ? 'complete' : 'draft'
        ]);
        const csvContent = "data:text/csv;charset=utf-8,"
            + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "soc_dataset.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Dataset exported successfully!");
    };

    const handleSortChange = (order) => {
        setSortOrder(order);
        const sorted = [...socList].sort((a, b) => {
            const timeA = new Date(a?.createdAt || 0).getTime();
            const timeB = new Date(b?.createdAt || 0).getTime();
            return order === 'latest' ? timeB - timeA : timeA - timeB;
        });
        setSocList(sorted);
    };

    const getPageNumbers = (totalPagesValue) => {
        const pages = [];
        const delta = 1;

        for (let i = 1; i <= totalPagesValue; i += 1) {
            if (
                i === 1 ||
                i === totalPagesValue ||
                (i >= currentPage - delta && i <= currentPage + delta)
            ) {
                pages.push(i);
            } else if (pages[pages.length - 1] !== '...') {
                pages.push('...');
            }
        }
        return pages;
    };

    const filteredSocList = (socList || []).filter((soc) => {
        const query = searchQuery.toLowerCase().trim();
        if (!query) return true;
        const certId = String(soc?.certificateId || '').toLowerCase();
        const address = String(soc?.address || '').toLowerCase();
        const owner = String(soc?.ownerName || userdetails?.name || '').toLowerCase();
        const status = soc?.certificateId ? 'complete' : 'draft';
        return certId.includes(query) || address.includes(query) || owner.includes(query) || status.includes(query);
    });

    const totalPages = Math.ceil(filteredSocList.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredSocList.slice(indexOfFirstItem, indexOfLastItem);

    const handleDeleteSoc = async (soc, event) => {
        event?.stopPropagation?.();
        if (!window.confirm("Are you sure you want to delete this SOC record?")) {
            return;
        }
        try {
            const response = await PropertiesService.DeleteProperty({
                deleteId: soc._id,
                deleteItem: 'soc'
            });
            if (typeof response === 'string' && response.toLowerCase().includes('error')) {
                throw new Error(response);
            }
            toast.success("SOC record deleted successfully");
            await fetchSocHistory();
        } catch (error) {
            toast.error(getBackendErrorMessage(error, "Failed to delete SOC record"));
        }
    };

    const socSealCode = generateUniqueSealCode(
        finalCertData?.certificateId,
        finalCertData?.ownerName || userdetails?.name,
        finalCertData?.createdAt
    );

    if (!isOpen) return null;

    const renderCertificateModal = () => {
        if (!showCertificate) return null;
        return (
            <div className="soc-modal-overlay">
                <div className="cert-modal-container">
                    <div className="cert-view animate-fadeIn">
                        <div className="soc-oc-certificate" ref={certificateRef}>
                            <div className="soc-oc-header">
                                <div className="soc-oc-top-actions" data-export-hide="true">
                                    <button
                                        className="soc-oc-download"
                                        onClick={downloadCertificate}
                                        disabled={isDownloading}
                                        title="Download Certificate PDF"
                                    >
                                        <FaDownload size={13} /> {isDownloading ? 'Downloading...' : 'Download PDF'}
                                    </button>
                                    <button className="soc-oc-close" onClick={() => setShowCertificate(false)} title="Close">✕</button>
                                </div>
                                <div className="soc-header-text">
                                    <DocityBlackWordmark />
                                    <h3>Self occupied Certificate</h3>
                                </div>
                            </div>

                            <p className="soc-oc-declaration">
                                <span className="soc-oc-declaration-line">This is to acknowledge and certify that</span>
                                <span className="soc-oc-owner-highlight">{finalCertData?.ownerName || userdetails?.name || 'Property Owner'}</span>
                                <span className="soc-oc-declaration-line">is the rightful occupier of the property submitted to DoCity Civil Engineers Private Limited.</span>
                                <span className="soc-oc-declaration-line">The details and supporting documents provided for this application are accepted as true to the best of the applicant's knowledge.</span>
                            </p>

                            <div className="soc-oc-details-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '0 16px 10px 16px', gap: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <span className="soc-oc-label" style={{ display: 'block' }}>PROPERTY ADDRESS</span>
                                    <span style={{ fontSize: '0.75rem', wordBreak: 'break-word' }}>
                                        {finalCertData?.address || socForm.propertyAddress.trim() || resolveUserAddress(userdetails) || 'Address not available'}
                                    </span>
                                </div>
                                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                    <span className="soc-oc-label" style={{ display: 'block' }}>CERTIFICATE EXPIRY</span>
                                    <span style={{ fontSize: '0.75rem' }}>{formatDisplayDate(finalCertData?.expiresAt)}</span>
                                </div>
                            </div>

                            <div className="soc-oc-footer-grid">
                                <div className="soc-oc-address-block">
                                    <div className="soc-oc-meta-col">
                                        <div className="soc-oc-qr-center soc-oc-qr-below-owner">
                                            <div className="soc-oc-qr-frame">
                                                {effectiveQrCode || finalCertData?.qrCodeData ? (
                                                    <a
                                                        href={
                                                            finalCertData?.downloadUrl ||
                                                            finalCertData?.certificateDownloadUrl ||
                                                            finalCertData?.pdfUrl ||
                                                            finalCertData?.certificateUrl ||
                                                            buildCertificateDownloadRoute('soc', finalCertData?.certificateId || finalCertData?._id || finalCertData?.id, {
                                                                ownerName: finalCertData?.ownerName || userdetails?.name || '',
                                                                address: finalCertData?.address || socForm?.propertyAddress?.trim() || resolveUserAddress(userdetails) || '',
                                                                expiresAt: finalCertData?.expiresAt || '',
                                                                issuedAt: finalCertData?.createdAt || '',
                                                            }) ||
                                                            "#"
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        title="Click or scan to download certificate"
                                                        style={{ cursor: 'pointer', display: 'inline-block' }}
                                                    >
                                                        <img src={effectiveQrCode || finalCertData.qrCodeData} className="soc-oc-qr" alt="QR Code" crossOrigin="anonymous" />
                                                    </a>
                                                ) : (
                                                    <FaQrcode size={56} />
                                                )}
                                            </div>
                                            <span className="soc-oc-qr-caption">Scan to download certificate</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="soc-oc-seal-wrap">
                                    <div className="soc-oc-seal" aria-label={`Unique seal ${socSealCode}`}>
                                        <svg viewBox="0 0 200 200" className="soc-oc-seal-svg" role="img" aria-label="Docity company seal">
                                            <defs>
                                                <path id="socSealTopArc" d="M 28 100 A 72 72 0 0 1 172 100" />
                                                <path id="socSealBottomArc" d="M 172 100 A 72 72 0 0 1 28 100" />
                                                <path id="socSealInnerArc" d="M 62 134 A 38 38 0 0 0 138 134" />
                                            </defs>

                                            <circle cx="100" cy="100" r="90" className="soc-seal-ring-outer" />
                                            <circle cx="100" cy="100" r="62" className="soc-seal-ring-mid" />

                                            <text className="soc-seal-text-arc soc-seal-text-top">
                                                <textPath href="#socSealTopArc" startOffset="50%" textAnchor="middle">DOCITY.CO.IN</textPath>
                                            </text>
                                            <text className="soc-seal-text-arc soc-seal-text-bottom">
                                                <textPath href="#socSealBottomArc" startOffset="50%" textAnchor="middle">THE DOCITY SEAL</textPath>
                                            </text>

                                            <text x="100" y="84" className="soc-seal-company" textAnchor="middle">DOCITY SEAL</text>
                                            <image href={logoEmblem} x="82" y="90" width="36" height="36" preserveAspectRatio="xMidYMid meet" className="soc-seal-logo-svg" />
                                        </svg>
                                    </div>
                                </div>

                                <div className="soc-oc-sign-wrap">
                                    <strong style={{
                                        fontFamily: "'Brush Script MT', 'Dancing Script', 'Georgia', cursive, serif",
                                        fontSize: '26px',
                                        fontWeight: '500',
                                        fontStyle: 'italic',
                                        color: '#0f4c81',
                                        display: 'inline-block',
                                        marginBottom: '2px',
                                        whiteSpace: 'nowrap'
                                    }}>DoCity</strong>

                                    <div className="soc-oc-sign-line" />

                                    <span>Authorised Signature</span>
                                </div>
                            </div>
                            <div className='disclaimer-text'>
                                <p className='dis-text'>DoCity does not take responsibility for the title or possession of this property.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    };

    if (activeTab === 'history') {
        return (
            <div className="soc-list-main-section">
                {/* Header Section outside the Card */}
                <div className="soc-list-top-header">
                    <div className="soc-list-top-left">

                    </div>
                    <div className="soc-list-top-actions">

                        <button className="soc-btn-issue" onClick={() => { setActiveTab('generate'); setActiveStep('step1'); }}>
                            <Plus size={16} />
                            <span>Create SOC</span>
                        </button>
                    </div>
                </div>

                {/* Main Card Container */}
                <div className="soc-table-card">
                    {/* Inner controls */}
                    <div className="soc-table-controls">
                        <div className="soc-table-search-wrap">
                            <Search size={18} className="soc-search-icon" />
                            <input
                                type="search"
                                className="soc-table-search-input"
                                onChange={(e) => setSearchQuery(e.target.value)}
                                value={searchQuery}
                                placeholder="Search by Certificate ID or Date..."
                            />
                        </div>
                        <div className="soc-table-right-controls">
                            <div className="soc-sort-dropdown-wrap">
                                <span className="soc-sort-label">Sort:</span>
                                <select
                                    className="soc-sort-select"
                                    value={sortOrder}
                                    onChange={(e) => handleSortChange(e.target.value)}
                                >
                                    <option value="latest">Latest First</option>
                                    <option value="oldest">Oldest First</option>
                                </select>
                            </div>
                            <button className="soc-filter-btn" title="Filter list">
                                <SlidersHorizontal size={18} />
                            </button>
                        </div>
                    </div>

                    {/* Table layout */}
                    <div className="soc-table-responsive">
                        <table className="soc-data-table">
                            <thead>
                                <tr>
                                    <th>Certificate ID</th>
                                    <th>Issuance Date</th>
                                    <th className="text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoadingList ? (
                                    <tr>
                                        <td colSpan="3">
                                            <div className="setInCenter">
                                                <FetchingCard message="" sub="Fetching details" />
                                            </div>
                                        </td>
                                    </tr>
                                ) : currentItems.length > 0 ? (
                                    currentItems.map((soc, index) => (
                                        <tr key={soc._id || index}>
                                            <td>
                                                <div className="soc-cert-cell" style={{ cursor: 'pointer' }} onClick={() => { setFinalCertData(soc); setShowCertificate(true); }}>
                                                    <div className="soc-cert-icon-box">
                                                        <ShieldCheck size={20} className="soc-cert-shield" />
                                                    </div>
                                                    <div>
                                                        <span className="soc-cert-code">
                                                            {getFormattedCertId(soc)}
                                                        </span>
                                                        <div style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '2px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={soc.address}>
                                                            {soc.address || 'No Address'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="soc-issuance-date">
                                                    {getFormattedIssuanceDate(soc)}
                                                </span>
                                            </td>
                                            <td className="text-right">
                                                <div className="soc-actions-cell">
                                                    <button
                                                        className="soc-action-btn view-btn"
                                                        onClick={() => { setFinalCertData(soc); setShowCertificate(true); }}
                                                    >
                                                        <Eye size={16} />
                                                        <span>View</span>
                                                    </button>
                                                    <button
                                                        className="soc-action-btn edit-btn"
                                                        onClick={(event) => handleEditSoc(soc, event)}
                                                    >
                                                        <Pencil size={14} />
                                                        <span>Edit</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">
                                            <div className="soc-empty-table-state">
                                                <p>{socList.length === 0 ? 'Get started by creating a new self-occupation certificate.' : 'Try refining your search query.'}</p>
                                                {socList.length === 0 && (
                                                    <a href="/" onClick={(e) => { e.preventDefault(); setActiveTab('generate'); setActiveStep('step1'); }} style={{ color: 'var(--color-turquoise-teal)', textDecoration: 'underline' }}>
                                                        Click here to request a SOC.
                                                    </a>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Table Footer / Pagination */}
                    {filteredSocList.length > 0 && (
                        <div className="soc-table-footer">
                            <div className="soc-footer-info">
                                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredSocList.length)} of {filteredSocList.length} certificates
                            </div>
                            <div className="soc-table-pagination-controls">
                                <button
                                    className="soc-page-nav-btn"
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    <ChevronLeft size={16} />
                                </button>
                                {getPageNumbers(totalPages).map((p, idx) => (
                                    p === '...' ? (
                                        <span key={`ell-${idx}`} className="soc-page-dots">...</span>
                                    ) : (
                                        <button
                                            key={`page-${p}`}
                                            className={`soc-page-num-btn ${currentPage === p ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(p)}
                                        >
                                            {p}
                                        </button>
                                    )
                                ))}
                                <button
                                    className="soc-page-nav-btn"
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages || totalPages === 0}
                                >
                                    <ChevronRight size={16} />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                {renderCertificateModal()}
            </div>
        );
    }

    return (
        <div className="prestige-page-bg animate-fadeIn" style={{ borderRadius: '12px', overflow: pageMode ? 'visible' : 'hidden' }}>
            <div className="prestige-main-container-fluid" data-onboarding="form-screen" style={{ margin: 0, width: '100%', height: '100%', borderRadius: '12px', boxShadow: 'none' }}>
                <div className="prestige-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', borderBottom: '1px solid var(--color-border)', padding: '14px 22px' }}>
                    <div className="prestige-stepper" style={{ margin: 0, padding: '10px 0 0 0', width: '100%', maxWidth: '600px' }}>
                        <div className={`prestige-step status-${getStepProgress("step1")} ${activeStep === "step1" ? "active" : ""}`} onClick={() => handleForms("step1")} style={{ cursor: 'pointer' }}>
                            <div className="prestige-step-circle">1</div>
                            <div className="prestige-step-label">Base Documents</div>
                        </div>
                        <div className={`prestige-step-line status-${getStepProgress("step1")}`}>
                            <div
                                className={`prestige-step-line-fill status-${getStepProgress("step1")}`}
                                style={{ width: `${getStepProgressPercent("step1")}%` }}
                            ></div>
                        </div>

                        <div className={`prestige-step status-${getStepProgress("step2")} ${activeStep === "step2" ? "active" : ""}`} onClick={() => handleForms("step2")} style={{ cursor: 'pointer' }}>
                            <div className="prestige-step-circle">2</div>
                            <div className="prestige-step-label">Verification</div>
                        </div>
                        <div className={`prestige-step-line status-${getStepProgress("step2")}`}>
                            <div
                                className={`prestige-step-line-fill status-${getStepProgress("step2")}`}
                                style={{ width: `${getStepProgressPercent("step2")}%` }}
                            ></div>
                        </div>

                        <div className={`prestige-step status-${getStepProgress("step3")} ${activeStep === "step3" ? "active" : ""}`} onClick={() => handleForms("step3")} style={{ cursor: 'pointer' }}>
                            <div className="prestige-step-circle">3</div>
                            <div className="prestige-step-label">Review</div>
                        </div>
                    </div>

                    <div className="prestige-header-nav" style={{ position: 'absolute', right: '22px', display: 'flex', gap: '16px' }}>
                        <span onClick={() => { setActiveTab('history'); }} style={{ cursor: 'pointer', color: 'var(--color-turquoise-teal)', fontWeight: 600 }}>List of Certificates</span>
                        <span onClick={onClose} style={{ cursor: 'pointer' }}>Close</span>
                    </div>
                </div>
                <div className="prestige-body" style={{ flex: 1 }}>
                    <div className="prestige-form-col">
                        <div className="prestige-content">
                            <form className="prestige-form" data-onboarding-form="soc" onSubmit={(e) => e.preventDefault()}>
                                {activeStep === 'step1' && (
                                    <>
                                        <div className="soc-grid" style={{ justifyContent: legacyFiles.length === 1 ? 'center' : 'flex-start' }}>
                                            {legacyFiles.map((file) => (
                                                <div key={file.id} className="document-card-small">
                                                    {!isViewMode && (
                                                        <div className="remove-upload-small" style={{ zIndex: 1001, background: 'rgba(255,255,255,0.9)', borderRadius: '50%', padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => removeLegacyFile(file.id)}>
                                                            <FaTimesCircle color="#e74c3c" size={20} />
                                                        </div>
                                                    )}
                                                    <input type="file" id={`legacy-file-${file.id}`} hidden onChange={(e) => handleLegacyFileUpload(e, file.id)} accept=".pdf,.png,.jpg,.jpeg" />
                                                    <div className="userImage-small" onClick={() => !isViewMode && document.getElementById(`legacy-file-${file.id}`)?.click()}>
                                                        {file.isLoading ? (
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '6px' }}>
                                                                <img src={loader} width="36" alt="loading" style={{ marginBottom: '4px' }} />
                                                                <p style={{ fontSize: '11px', color: 'var(--color-turquoise-teal)', fontWeight: '600', margin: 0, textAlign: 'center' }}>Uploading...</p>
                                                            </div>
                                                        ) : file.data ? (
                                                            <FilePreview title="doc" className="mini-preview" url={file.downloadUrl || file.data} previewUrl={file.data} fileSize={file.fileSize} isPreviewUrl={true} />
                                                        ) : (
                                                            <div className="upload-placeholder-small"><img src={uploadIcon} width="28" alt="upload" /><p>Select Document</p></div>
                                                        )}
                                                    </div>
                                                    {file.data && !file.isLoading && (
                                                        <div className="date-area-small">
                                                            {file.isExtracting ? (
                                                                <p style={{ color: 'var(--color-turquoise-teal)', fontSize: '11px', fontWeight: '600', margin: '4px 0 0 0', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                                    <img src={loader} width="14" alt="reading" /> Reading document date... please wait...
                                                                </p>
                                                            ) : (
                                                                <>
                                                                    <input type="date" value={file.manualDate || ''} className="form-control-sm" max={today} disabled={isViewMode} onChange={(e) => handleLegacyDateChange(file.id, 'manualDate', e.target.value)} />
                                                                    {file.manualDate && (
                                                                        <>
                                                                            <p style={{ fontSize: '11px', color: 'var(--color-turquoise-teal)', fontWeight: '600', margin: '3px 0 0 0', textAlign: 'center' }}>
                                                                                {formatReadableDate(file.manualDate)}
                                                                            </p>
                                                                            <div className="confirm-row">
                                                                                <span>Verified</span>
                                                                                <input type="checkbox" checked={file.declare || false} disabled={isViewMode} onChange={(e) => handleLegacyDateChange(file.id, 'declare', e.target.checked)} />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            {!isViewMode && (
                                                <div className="add-doc-small-tile" onClick={addNewUploadSlot}>
                                                    <img src={addIcon} width="25" alt="add" /><span>Add More</span>
                                                </div>
                                            )}
                                        </div>
                                        {uploadFieldErrors.legacyFiles && <p className="soc-inline-error">{uploadFieldErrors.legacyFiles}</p>}

                                        {/* Owner Name - auto-extracted or manual input */}
                                        {legacyFiles.some(f => f.data && !f.isLoading) && (
                                            <div className="soc-owner-name-section">
                                                <h6 className="soc-owner-name-heading">Owner Name (As per Document)</h6>
                                                {isExtractingName ? (
                                                    <p style={{ color: 'var(--color-turquoise-teal)', fontSize: '12px', fontWeight: '600', margin: '4px 0 0 0', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <img src={loader} width="14" alt="reading" /> Reading owner name from document... please wait...
                                                    </p>
                                                ) : (ownerNameSource === 'extracted' || ownerNameSource === 'saved') && socForm.ownerName && !isOwnerNameEditing ? (
                                                    <div className="soc-owner-extracted">
                                                        <div className="soc-owner-extracted-badge">
                                                            <FaCheckCircle className="soc-owner-check-icon" />
                                                            <span className="soc-owner-extracted-label">
                                                                {ownerNameSource === 'saved' ? 'Saved Owner Name' : 'Auto-read from document'}
                                                            </span>
                                                        </div>
                                                        <div className="soc-owner-extracted-value">
                                                            <span>{socForm.ownerName}</span>
                                                            {!isViewMode && (
                                                                <button
                                                                    type="button"
                                                                    className="soc-owner-edit-btn"
                                                                    onClick={() => setIsOwnerNameEditing(true)}
                                                                    title="Edit owner name"
                                                                >
                                                                    <FaEdit size={14} /> Edit
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="soc-owner-manual">
                                                        {!socForm.ownerName && ownerNameSource !== 'extracted' && ownerNameSource !== 'saved' && (
                                                            <div className="soc-owner-manual-hint">
                                                                <FaInfoCircle className="soc-owner-info-icon" />
                                                                <span>Owner name could not be read from the document. Please enter it manually.</span>
                                                            </div>
                                                        )}
                                                        <input
                                                            type="text"
                                                            className="form-control soc-owner-name-input"
                                                            placeholder="Enter owner name as mentioned in the document..."
                                                            value={socForm.ownerName}
                                                            onChange={(e) => {
                                                                setSocForm((prev) => ({ ...prev, ownerName: e.target.value }));
                                                                if (!ownerNameSource) setOwnerNameSource('manual');
                                                            }}
                                                            disabled={isViewMode}
                                                        />
                                                        {!isViewMode && !socForm.ownerName?.trim() && (
                                                            <p className="soc-inline-error" style={{ color: '#dc3545', marginTop: '6px' }}>
                                                                Owner Name is required to proceed.
                                                            </p>
                                                        )}
                                                        {isOwnerNameEditing && (
                                                            <button
                                                                type="button"
                                                                className="soc-owner-cancel-edit"
                                                                onClick={() => setIsOwnerNameEditing(false)}
                                                            >
                                                                Cancel
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {isViewMode ? (
                                            <button className="btn-soc-submit" onClick={handleBackToGenerateTab}>Back to Generate</button>
                                        ) : (
                                            <button
                                                className={`btn-soc-submit ${!isLegacyReady ? 'disabled' : ''}`}
                                                disabled={!isLegacyReady || isSaving}
                                                onClick={handleLegacyGenerate}
                                            >
                                                {isSaving ? 'Saving...' : isEditMode ? 'Update' : 'Generate'}
                                            </button>
                                        )}
                                    </>
                                )}

                                {activeStep === 'step2' && (
                                    <>
                                        <div className="soc-grid" style={{ justifyContent: 'flex-start' }}>

                                            <div className="document-card-small" style={{ width: '100%', height: 'auto' }}>
                                                <h6>1. Post Office Selfie - Upload</h6>
                                                <input
                                                    id="soc-property-pictures-upload"
                                                    type="file"
                                                    accept=".pdf,.png,.jpg,.jpeg,.DOC,.DOCX"
                                                    multiple
                                                    onChange={(e) => uploadFiles(e, 'PostOfficeSelfies', true)}
                                                    hidden
                                                />
                                                <div className="soc-upload-card-frame" onClick={() => openHiddenFileInput('soc-property-pictures-upload')}>
                                                    {socForm.PostOfficeSelfies.length > 0 ? (
                                                        <div style={{ position: "relative", width: "100%" }}>
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removeUploadedItem('PostOfficeSelfies', 0);
                                                                }}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 8,
                                                                    right: 8,
                                                                    zIndex: 1001,
                                                                    border: "none",
                                                                    background: "rgba(255,255,255,0.95)",
                                                                    borderRadius: "50%",
                                                                    width: 24,
                                                                    height: 24,
                                                                    fontSize: 16,
                                                                    lineHeight: "24px",
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    color: "var(--color-oxford-blue)",
                                                                }}
                                                                aria-label="Remove file"
                                                            >
                                                                ×
                                                            </button>
                                                            <FilePreview
                                                                url={socForm.PostOfficeSelfies[0]?.previewUrl || socForm.PostOfficeSelfies[0]?.downloadUrl}
                                                                width="100%"
                                                                height="170px"
                                                                title="Property Picture"
                                                                className="document-preview"
                                                                style={{ border: "none" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="soc-upload-card-body">
                                                            <img src={uploadIcon} width={36} alt="Upload" />
                                                            <p>Select Document</p>
                                                        </div>
                                                    )}
                                                </div>
                                                {uploading.PostOfficeSelfies && <p className="mt-2 mb-0 text-muted">Uploading...</p>}
                                                {uploadFieldErrors.PostOfficeSelfies && <p className="soc-inline-error">{uploadFieldErrors.PostOfficeSelfies}</p>}
                                            </div>

                                            <div className="document-card-small" style={{ width: '100%', height: 'auto' }}>
                                                <h6>2. Property Address</h6>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter the property address..."
                                                    rows={3}
                                                    value={socForm.propertyAddress}
                                                    onChange={(e) => setSocForm((prev) => ({ ...prev, propertyAddress: e.target.value }))}
                                                    style={{ resize: 'vertical', fontSize: '0.85rem' }}
                                                />
                                            </div>
                                            <div className="document-card-small" style={{ width: '100%', height: 'auto' }}>

                                                <div className="mb-2">
                                                    <label className="soc-consent-label">
                                                        <input
                                                            type="checkbox"
                                                            name="illegalActivityConsentChoice"
                                                            checked={socForm.illegalActivityConsentChoice === 'pledgeNoIllegalActivity'}
                                                            onChange={(e) => setSocForm((prev) => ({
                                                                ...prev,
                                                                illegalActivityConsentChoice: e.target.checked ? 'pledgeNoIllegalActivity' : '',
                                                            }))}
                                                        />
                                                        <span className="soc-consent-text-wrap">
                                                            <span className="soc-consent-text">I hereby declare, as the owner of the above-mentioned property, that it complies with applicable sustainability standards, and that all information provided above is true and accurate to the best of my knowledge.</span>
                                                            {/* <span className="soc-consent-info" tabIndex={0} aria-label="Meaning of unlawful activity">
                                                                <FaInfoCircle />
                                                                <span className="soc-consent-tooltip">
                                                                    Unlawful activity means any act that is against the law, such as fraud, violence, smuggling, narcotics, or any criminal misuse of the property.<br />

                                                                    <span className="mt-1 d-block">
                                                                        I would say for no drugs and no terrarism
                                                                    </span>
                                                                </span>
                                                            </span> */}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                        </div>

                                        <p className="request-submit-note mb-2 mt-2">
                                            Note: Just to confirm, you are not buying the property you are submitting.
                                        </p>

                                        <div style={{ display: 'flex', gap: '10px', marginTop: '14px' }}>
                                            <button className="btn-soc-submit" onClick={() => setActiveStep('step1')}>
                                                Back
                                            </button>
                                            {isEditMode ? (
                                                <button className={`btn-soc-submit ${!isReadyForCertificate || isSaving ? 'disabled' : ''}`} disabled={!isReadyForCertificate || isSaving} onClick={handleUpdateSoc}>
                                                    {isSaving ? 'Updating...' : 'Update SOC'}
                                                </button>
                                            ) : (
                                                <button className={`btn-soc-submit ${!isReadyForCertificate ? 'disabled' : ''}`} disabled={!isReadyForCertificate} onClick={handleProceedToSocPayment}>
                                                    Continue to Payment
                                                </button>
                                            )}
                                        </div>
                                    </>
                                )}

                                {activeStep === 'step3' && (
                                    <>
                                        <div className="soc-payment-screen">
                                            <div className="soc-payment-panel">
                                                <div className="soc-payment-chip">All checks completed</div>
                                                <h4 className="soc-payment-title">SOC verification summary</h4>
                                                <p className="soc-payment-subtitle">
                                                    Review the completed checks before payment. You can use Pay Later to generate the certificate immediately.
                                                </p>

                                                <div className="soc-payment-checklist">
                                                    {socPaymentChecks.map((item) => (
                                                        <div key={item.label} className={`soc-payment-check-item ${item.completed ? 'completed' : 'pending'}`}>
                                                            <div className="soc-payment-check-icon">{item.completed ? '✓' : '•'}</div>
                                                            <div className="soc-payment-check-content">
                                                                <p>{item.label}</p>
                                                                <span>{item.detail}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="soc-payment-panel soc-payment-preview-panel">
                                                <h4 className="soc-payment-title">SOC payment service</h4>
                                                <p className="soc-payment-subtitle">
                                                    The payment summary below follows the same review style used in other DoCity verification flows.
                                                </p>

                                                <PaymentPreviewCard
                                                    baseAmount={SOC_BASE_AMOUNT}
                                                    discount={SOC_DISCOUNT}
                                                    gstRate={SOC_GST_RATE}
                                                    servicePoints={socPaymentServicePoints}
                                                />

                                                <div className="soc-payment-note-box" style={{ marginTop: '10px' }}>
                                                    <strong>Aadhaar verification</strong>
                                                    <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                                        <input
                                                            type="text"
                                                            value={aadhaarNumber}
                                                            onChange={handleAadhaarNumberChange}
                                                            placeholder="Enter 12-digit Aadhaar number"
                                                            maxLength={12}
                                                            className="form-control"
                                                            style={{ height: '34px', fontSize: '14px', padding: '4px 10px' }}
                                                        />
                                                        {!isAadhaarVerified && (
                                                            <button
                                                                className="btn-soc-submit soc-btn-secondary"
                                                                type="button"
                                                                onClick={handleSendAadhaarOtp}
                                                                disabled={isSendingAadhaarOtp || aadhaarNumber.length !== 12}
                                                                style={{ height: '34px', padding: '4px 12px', fontSize: '14px' }}
                                                            >
                                                                {isSendingAadhaarOtp ? 'Sending...' : 'Verify'}
                                                            </button>
                                                        )}
                                                        {isAadhaarVerified && (
                                                            <span style={{ color: 'var(--color-turquoise-teal)', alignSelf: 'center', fontWeight: 600 }}>Verified ✓</span>
                                                        )}
                                                    </div>
                                                    {aadhaarError && <p className="error mt-2 mb-0">{aadhaarError}</p>}
                                                </div>

                                                {/* <div className="soc-payment-note-box">
                                                    <strong>Pay Later:</strong> If you choose Pay Later, the SOC certificate will be generated right away and you can complete payment later.
                                                </div> */}
                                            </div>
                                        </div>

                                        <div className="soc-payment-actions">
                                            <button className="btn-soc-submit soc-btn-secondary" onClick={() => setActiveStep('step2')}>
                                                Back
                                            </button>
                                            {/* <button className={`btn-soc-submit ${!isSocPaymentReady || isSaving || !isAadhaarVerified ? 'disabled' : ''}`} disabled={!isSocPaymentReady || isSaving || !isAadhaarVerified} onClick={handleGenerateCertificate}>
                                                {isSaving ? 'Generating...' : 'Pay Later & Generate SOC'}
                                            </button> */}
                                            <button className={`btn-soc-submit ${!isSocPaymentReady || isSaving || !isAadhaarVerified ? 'disabled' : ''}`} disabled={!isSocPaymentReady || isSaving || !isAadhaarVerified} onClick={() => setRazorPayShow(true)}>
                                                Pay Now & Generate SOC
                                            </button>
                                        </div>
                                        {showAadhaarOtpModal && (
                                            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                                                <div style={{ width: '360px', background: '#fff', borderRadius: '10px', padding: '16px' }}>
                                                    <h5 style={{ marginBottom: '10px' }}>Verify Aadhaar OTP</h5>
                                                    <input
                                                        type="text"
                                                        value={aadhaarOtp}
                                                        onChange={handleAadhaarOtpChange}
                                                        placeholder="Enter 6-digit OTP"
                                                        maxLength={6}
                                                        className="form-control"
                                                    />
                                                    {aadhaarError && <p className="error mt-2 mb-0">{aadhaarError}</p>}
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '14px' }}>
                                                        <button className="btn-soc-submit soc-btn-secondary" type="button" onClick={() => setShowAadhaarOtpModal(false)}>
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="btn-soc-submit"
                                                            type="button"
                                                            onClick={handleVerifyAadhaarOtp}
                                                            disabled={isVerifyingAadhaarOtp || aadhaarOtp.length !== 6}
                                                        >
                                                            {isVerifyingAadhaarOtp ? 'Submitting...' : 'Submit'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            {false && console.log(aadhaarSuccessMessage, handleViewSocInGenerate, exportToCSV, handleDeleteSoc)}
            {renderCertificateModal()}

            <Modal show={RazorPayShow} size="md" onHide={() => setRazorPayShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '18px', fontWeight: 600 }}>Pay via Razorpay (Test Mode)</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex justify-content-center">
                    <div className="card-body p-4 w-100 text-center">
                        <Product
                            amount={SOC_NET_AMOUNT}
                            gstRate={SOC_GST_RATE}
                            currency="INR"
                            paymentFor="SOC"
                            userId={resolvedUserId || userdetails?.user_id}
                            onPaymentStatusChange={async (status) => {
                                setPaymentStatus(status);
                                if (status === true) {
                                    try {
                                        await handleGenerateCertificate();
                                    } catch (err) {
                                        console.error('SOC generation after payment failed:', err);
                                    } finally {
                                        setRazorPayShow(false);
                                    }
                                }
                            }}
                            paymentStatus={paymentStatus}
                            paymentMessage="SOC"
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SOC;
